import { combineReducers } from '@reduxjs/toolkit';

import { callerSessionReducer } from 'features/caller-session/store';
import { astSignMailReducer } from 'features/ast-signmail/store';
import { appConfigReducer } from 'features/app-config/store';
import { appLoadingReducer } from 'features/app-loading/store';
import appReducer from 'features/app/store/app/appSlice';
import { audioReducer } from 'features/call/call-base/store/audioSlice';
import { callReducer } from 'features/call/call-base/store/callSlice';
import { conferenceReducer } from 'features/call/call-conference/store';
import { callDeafReducer } from 'features/call/call-deaf/store';
import { callDetailsReducer } from 'features/call/call-details/store';
import { callHearingReducer } from 'features/call/call-hearing/store';
import { callTimerReducer } from 'features/call/call-timer/store';
import { callCaptionsReducer } from 'features/call/call-captions';
import { previousCallsReducer } from 'features/call/previous-calls/store';
import { vrsCallCommentsReducer } from 'features/call/vrs-call-comments/store';
import { vrsCallReducer } from 'features/call/vrs-call/store';
import { vrsConferenceCallReducer } from 'features/call/vrs-conference-call/store';
import { coldHandoffReducer } from 'features/cold-handoff/store';
import { customGreetingReducer } from 'features/custom-greeting/store';
import { deafPhoneNumberHiddenReducer } from 'features/deaf-phone-number-hidden/store';
import { dialPadReducer } from 'features/dial-pad/store';
import { dialedNumbersHistoryReducer } from 'features/dialed-numbers-history/store';
import { emergencyReducer } from 'features/emergency/store';
import { localVideoReducer } from 'features/local-video/store';
import { machinePreferencesReducer } from 'features/machine-preferences/store';
import { mediaDevicesReducer } from 'features/media-devices/store';
import monitorReducer from 'features/monitoring/store/monitoringSlice';
import { multiModeReducer } from 'features/multi-mode/store';
import { notificationReducer } from 'features/notification/store';
import { shareTextReducer } from 'features/share-text/store';
import { queueSettingsReducer } from 'features/queue-settings/store';
import { reportingReducer } from 'features/reporting/store';
import { sessionReducer } from 'features/session/store';
import { signMailReducer } from 'features/signmail/store';
import { sipConnectionReducer } from 'features/sip/store';
import { spawnCallReducer } from 'features/spawn-call/store';
import { statsReducer } from 'features/stats/store';
import { teamingReducer } from 'features/teaming/teaming-base/store';
import { userReducer } from 'features/user/store';
import { vcoReducer } from 'features/vco/store';
import { videoPrivacyReducer } from 'features/video-privacy/store';
import {
  voiceSessionHandoffReducer,
  voiceSessionReducer,
} from 'features/voice-session/store';
import { vpnBehaviorReducer } from 'features/vpn-behavior/store';
import { vriChatReducer } from 'features/vri-chat/store';
import { vrsChatReducer } from 'features/vrs-chat/store';
import { callUiManagerReducer } from 'features/call/call-ui-state/store';
import { trainingForkerReducer } from 'features/training-forker/store';
import { remoteMediaDetectionsReducer } from 'features/remote-media/store';
import { wsBridgeReducer } from 'features/wsbridge/store';

export const rootReducer = combineReducers({
  app: appReducer,
  appConfig: appConfigReducer,
  appLoading: appLoadingReducer,
  astSignMail: astSignMailReducer,
  audio: audioReducer,
  call: callReducer,
  callDeaf: callDeafReducer,
  callDetails: callDetailsReducer,
  callerSession: callerSessionReducer,
  callHearing: callHearingReducer,
  callTimer: callTimerReducer,
  callCaptions: callCaptionsReducer,
  callUiManager: callUiManagerReducer,
  coldHandoff: coldHandoffReducer,
  conference: conferenceReducer,
  customGreeting: customGreetingReducer,
  deafPhoneNumberHidden: deafPhoneNumberHiddenReducer,
  dialedNumbersHistory: dialedNumbersHistoryReducer,
  dialPad: dialPadReducer,
  emergency: emergencyReducer,
  localVideo: localVideoReducer,
  machinePreferences: machinePreferencesReducer,
  mediaDevices: mediaDevicesReducer,
  monitor: monitorReducer,
  multiMode: multiModeReducer,
  notification: notificationReducer,
  shareText: shareTextReducer,
  previousCalls: previousCallsReducer,
  queueSettings: queueSettingsReducer,
  remoteMediaDetections: remoteMediaDetectionsReducer,
  reporting: reportingReducer,
  session: sessionReducer,
  signMail: signMailReducer,
  sipConnection: sipConnectionReducer,
  spawnCall: spawnCallReducer,
  stats: statsReducer,
  teaming: teamingReducer,
  trainingForker: trainingForkerReducer,
  user: userReducer,
  vco: vcoReducer,
  videoPrivacy: videoPrivacyReducer,
  voiceSession: voiceSessionReducer,
  voiceSessionHandoff: voiceSessionHandoffReducer,
  vpnBehavior: vpnBehaviorReducer,
  vriChat: vriChatReducer,
  vrsCall: vrsCallReducer,
  vrsCallComments: vrsCallCommentsReducer,
  vrsChat: vrsChatReducer,
  vrsConferenceCall: vrsConferenceCallReducer,
  wsBridge: wsBridgeReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
